module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lte-timeline timeline"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87ee83b2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/timeline.vue
// module id = 39
// module chunks = 0